import styled, { css } from "styled-components/native";
import { LabelProps } from "./model";
import { palladium } from "../../StyleHelpers";

export const StyledContainer = styled.View`
	width: 100%;
`;

export const StyledChildMargin = styled.View<LabelProps>`
	${(props) =>
		props.addMarginChild &&
		css`
			margin-left: 20px;
		`}
`;

export const StyledText = styled.View`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const IconImage = styled.View`
	margin-left: 5px;
	width: 40px;
	height: 40px;
`;

export const StyledFooterContainer = styled.View`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const StyledMainContainer = styled.View`
	flex-direction: row;
	align-items: center;
`;

//Group Container
export const StyledGroupContainer = styled.View`
	flex-direction: row;
	justify-content: space-between;
`;

export const StyledButton = styled.View`
	width: 344px;
	height: 72px;
`;

export const StyledLoadHeader = styled.View`
	width: 400px;
	height: 24px;
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: 20px;
`;

export const StyledLoadBody = styled.View`
	width: 200px;
	height: 18px;
	border-radius: 16px;
	overflow: hidden;
`;

export const StyledTextContainer = styled.View`
	width: 26.04vw;
`;

export const StyledTextGroup = styled.Text`
	color: ${palladium};
`;

export const StyledTextMain = styled.View`
	flex: 1;
`;
